import { useState } from 'react';

import { CategoryDTO } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';

import PencilIcon from '@/components/icons/pencil';
import { Badge } from '@/components/ui/badge';

import { UpdateWorkspaceIssueCategories } from './update-workspace-issue-category';

function IssueCategories({
  onCategoriesChange,
  issueCategories,
  disabled = false,
}: {
  onCategoriesChange: (issueCategories: CategoryDTO[]) => void;
  issueCategories: CategoryDTO[] | undefined;
  disabled?: boolean;
}) {
  const [openIssuesCategoriesUpdate, setOpenIssuesCategoriesUpdate] = useState(false);

  return (
    <div className="flex w-full items-start gap-4">
      <p className="text-default-text w-[350px] shrink-0 text-sm">Issue categories</p>
      <div className="flex min-w-px flex-1 flex-col gap-2">
        {issueCategories && issueCategories.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {issueCategories.map((issueCategory) => (
              <Badge key={issueCategory.id} variant="violet" size="sm">
                {issueCategory.name}
              </Badge>
            ))}
          </div>
        ) : (
          <div className="text-secondary-text text-sm">No issue categories have been created yet.</div>
        )}
        {!disabled && (
          <Button
            variant="ghost"
            type="button"
            icon={<PencilIcon />}
            className="bg-grey-1 hover:bg-grey-3 w-fit"
            onClick={() => {
              setOpenIssuesCategoriesUpdate(true);
            }}>
            Edit Categories
          </Button>
        )}
      </div>

      <UpdateWorkspaceIssueCategories
        issueCategories={issueCategories}
        open={openIssuesCategoriesUpdate}
        onOpenChange={setOpenIssuesCategoriesUpdate}
        callback={onCategoriesChange}
      />
    </div>
  );
}

export default IssueCategories;
